import { ActionType } from '../enums/bottom-strip';

export type BottomStripDetail = {
    header: { text: string; subtext: string; lottie: string };
    button: {
        text: string;
        params: { tracking_id?: string };
        action_type: ActionType;
        action_url: string;
        cross_button: boolean;
    };
};

export const cartStrip: BottomStripDetail = {
    header: { text: 'You left something in your cart', subtext: 'Don’t resist, order it!', lottie: 'cart' },
    button: { text: 'VIEW', params: {}, action_type: ActionType.Cart, action_url: '', cross_button: false }
};
